export default __webpack_public_path__ + "static/media/ilian_xl.95f885c3.jpg";